import React, { useState } from 'react'
// import ReactApexChart from 'react-apexcharts';
import TryNewBatteryDigitalTwin from './TryNewBatteryDigitalTwin';
import TreemapChart from './TreemapChart';
// import TestingChart from './TestingChart';
// import ChartComponent from './ChartComponent';
// import TrendNew from './TrendNew';
// import TrendChart from './TrendChart';
// import TreandAct from './TreandAct';
// import HelloTrend from './HelloTrend';
// import Wijmo from './Wijmo';

export default function BatteryDigitalTwinTest() {

  const [series, setSeries] = useState([75]);
  const [options, setOptions] = useState({
    colors: ['#008000'],
    chart: {
      type: 'radialBar',
      offsetY: -20,
      sparkline: {
        enabled: true
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "#e7e7e7",
          strokeWidth: '97%',
          margin: 5,
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            color: '#999',
            opacity: 1,
            blur: 2
          }
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: -2,
            fontSize: '15px'
          }
        },
        range: {
          min: 0,
          max: 100,
          background: [
            {
              from: 0,
              to: 76,
              color: '#008000'
            },
            {
              from: 76,
              to: 100,
              color: '#e7e7e7'
            }
          ]
        }
      }
    },
    grid: {
      padding: {
        top: -10
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 53, 91]
      },
    },
    labels: ['Average Results'],
  });

  // const [showSecondImage, setShowSecondImage] = useState(false);

  // const handleClick = () => {
  //   setShowSecondImage(true);
  // };

  const [showSecondImage, setShowSecondImage] = useState(false);
  const [showThirdImage, setShowThirdImage] = useState(false);
  const handleFirstImageClick = () => {
    setShowSecondImage(true);
  };

  const handleSecondImageClick = () => {
    setShowThirdImage(true);
  };

  return (
    <>
      {/* {showSecondImage ? (
        <img src="../../../assets/img_Bus/BDT_second_page_fake.png" width={"100%"} height={"100%"} />
      ) : (
        <img src="../../../assets/img_Bus/BDT_first_page_fake.png" width={"100%"} height={"100%"} alt="First Image" onClick={handleClick} style={{ cursor: 'pointer' }} />
      )} */}

      {showThirdImage ? (
        <img src="../../../assets/img_Bus/BDT_third_page_fake.png" width={"100%"} height={"100%"} alt="Third Image" />
      ) : showSecondImage ? (
        <img src="../../../assets/img_Bus/BDT_second_page_fake.png" width={"100%"} height={"100%"} alt="Second Image" onClick={handleSecondImageClick} style={{ cursor: 'pointer' }} />
      ) : (
        <img src="../../../assets/img_Bus/BDT_first_page_fake.png" width={"100%"} height={"100%"} alt="First Image" onClick={handleFirstImageClick} style={{ cursor: 'pointer' }} />
      )}

      {/* <img src="../../../assets/img_Bus/drive_analysis_bus.png" /> */}
      {/* <img src="../../../assets/img_Bus/BDT_first_page_fake.png" width={"100%"} height={"100%"} /> */}
      {/* <Wijmo /> */}
      {/* <HelloTrend /> */}
      {/* <TreandAct /> */}
      {/* <div className='mt-3'>
        <div id="chart" style={{ height: "500px", width: "250px" }}>
          <ReactApexChart options={options} series={series} type="radialBar" />
        </div>
      </div>
      <div> */}
      {/* <TryNewBatteryDigitalTwin /> */}
      {/* original
      <TestingChart />
      original */}
      {/* <TreemapChart /> */}
      {/*  <ChartComponent />
        <TrendNew /> */}
      {/* </div> */}
      {/* <TrendChart /> */}
    </>
  )
}
